import { useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import { useToasts } from "react-toast-notifications";
import Loader from "components/Loader";
import ResponseContainer from "./ResponseContainer";
import TeamService from "services/TeamService";

const AIAssistanceResponseList = ({
  query,
  open,
  handleModal,
  postonTimeline,
  createTodo,
  allowTodo,
  sOption,
  allowUpdate = true,
  isStatusPost = false,
}) => {
  const [response, setResponse] = useState("");
  const [hasResponse, setHasResponse] = useState(false);
  const [loading, setLoading] = useState(false);
  const { addToast } = useToasts();

  useEffect(() => {
    if (!open) return;

    (async () => {
      try {
        setResponse(null);
        setLoading(true);
        const summary = await TeamService.generiaAIGen({
          query: query,
          type: isStatusPost
            ? "STATUS-POST"
            : sOption.ideaId === 2
            ? "ANNOUNCEMENT-GEN"
            : "BRIGHT-IDEA",
        });
        const res = summary.data.data;
        setHasResponse(res.response?.overallSummary);
        setResponse(res.response);
        setLoading(false);
      } catch (e) {
        addToast("Some error occurred while generating summary", {
          appearance: "error",
        });
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={handleModal}
      showCloseIcon={false}
      classNames={{
        modalContainer: "modalContainer",
        modal: "queryModalContainer",
      }}
    >
      <div className="confirmationModalContent">
        <div className="chatGptQueryHeader">
          <h5 className="text-center confirmationModalHeader">
            {sOption.ideaId === 2 ? `Announce Gen` : `Summarizer`}
          </h5>
          <span className="chatgptCloseModal">
            <CancelIcon className="closeIcon" onClick={handleModal} />
          </span>
        </div>
        <hr />
        {!loading && !hasResponse && (
          <div className="chatGptLoaderContainer">
            Couldn't generate summary for this text
          </div>
        )}
        {loading && (
          <div className="chatGptLoaderContainer">
            <Loader height="60" width="60" />
          </div>
        )}
        {!loading && hasResponse && (
          <div className="chatGptQueryContent mb-3">
            <div>
              <div className="chatGptQuery mb-3">
                <ResponseContainer
                  response={response}
                  handleModal={handleModal}
                  postonTimeline={postonTimeline}
                  createTodo={createTodo}
                  allowTodo={sOption.ideaId === 2 ? false : allowTodo}
                  allowUpdate={allowUpdate}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AIAssistanceResponseList;
